var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetstalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 62.55,
    width: 23.07,
    height: 490.57,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.61,553.62h-24.07V62.05h24.07v491.57Zm-23.07-1h22.07V63.05h-22.07v489.57Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 328.18,
    y: 553.12,
    width: 32.79,
    height: 18.21,
    rx: 2.56,
    ry: 2.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,571.84h-27.66c-1.69,0-3.06-1.37-3.06-3.06v-13.09c0-1.69,1.37-3.06,3.06-3.06h27.66c1.69,0,3.06,1.37,3.06,3.06v13.09c0,1.69-1.37,3.06-3.06,3.06Zm-27.66-18.21c-1.14,0-2.06,.92-2.06,2.06v13.09c0,1.14,.92,2.06,2.06,2.06h27.66c1.14,0,2.06-.92,2.06-2.06v-13.09c0-1.14-.92-2.06-2.06-2.06h-27.66Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 328.18,
    y: 44.34,
    width: 32.79,
    height: 18.21,
    rx: 2.56,
    ry: 2.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,63.05h-27.66c-1.69,0-3.06-1.37-3.06-3.06v-13.09c0-1.69,1.37-3.06,3.06-3.06h27.66c1.69,0,3.06,1.37,3.06,3.06v13.09c0,1.69-1.37,3.06-3.06,3.06Zm-27.66-18.21c-1.14,0-2.06,.92-2.06,2.06v13.09c0,1.14,.92,2.06,2.06,2.06h27.66c1.14,0,2.06-.93,2.06-2.06v-13.09c0-1.14-.92-2.06-2.06-2.06h-27.66Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.86,
    y: 62.55,
    width: 23.07,
    height: 490.57,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.43,553.62h-24.07V62.05h24.07v491.57Zm-23.07-1h22.07V63.05h-22.07v489.57Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 553.12,
    width: 32.79,
    height: 18.21,
    rx: 2.56,
    ry: 2.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.23,571.84h-27.66c-1.69,0-3.06-1.37-3.06-3.06v-13.09c0-1.69,1.37-3.06,3.06-3.06h27.66c1.69,0,3.06,1.37,3.06,3.06v13.09c0,1.69-1.37,3.06-3.06,3.06Zm-27.66-18.21c-1.14,0-2.06,.92-2.06,2.06v13.09c0,1.14,.92,2.06,2.06,2.06h27.66c1.14,0,2.06-.92,2.06-2.06v-13.09c0-1.14-.92-2.06-2.06-2.06h-27.66Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 44.34,
    width: 32.79,
    height: 18.21,
    rx: 2.56,
    ry: 2.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.23,63.05h-27.66c-1.69,0-3.06-1.37-3.06-3.06v-13.09c0-1.69,1.37-3.06,3.06-3.06h27.66c1.69,0,3.06,1.37,3.06,3.06v13.09c0,1.69-1.37,3.06-3.06,3.06Zm-27.66-18.21c-1.14,0-2.06,.92-2.06,2.06v13.09c0,1.14,.92,2.06,2.06,2.06h27.66c1.14,0,2.06-.93,2.06-2.06v-13.09c0-1.14-.92-2.06-2.06-2.06h-27.66Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.93,
    y: 166.98,
    width: 264.11,
    height: 20.64,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,188.12H68.43v-21.64H333.54v21.64Zm-264.11-1H332.54v-19.64H69.43v19.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.93,
    y: 281.12,
    width: 264.11,
    height: 20.64,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,302.26H68.43v-21.64H333.54v21.64Zm-264.11-1H332.54v-19.64H69.43v19.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.93,
    y: 395.26,
    width: 264.11,
    height: 20.64,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,416.41H68.43v-21.64H333.54v21.64Zm-264.11-1H332.54v-19.64H69.43v19.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.93,
    y: 497.26,
    width: 264.11,
    height: 20.64,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,518.41H68.43v-21.64H333.54v21.64Zm-264.11-1H332.54v-19.64H69.43v19.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.24,
    y: 76.67,
    width: 27.67,
    height: 89.95,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.41,167.12h-28.67V76.17h28.67v90.95Zm-27.67-1h26.67V77.17h-26.67v88.95Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.84,
    y: 85.45,
    width: 27.67,
    height: 81.17,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.01,167.12h-28.67V84.95h28.67v82.17Zm-27.67-1h26.67V85.95h-26.67v80.17Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 267.52,
    y: 85.45,
    width: 21.55,
    height: 81.17,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.57,167.12h-22.55V84.95h22.55v82.17Zm-21.55-1h20.55V85.95h-20.55v80.17Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.34,
    y: 98.76,
    width: 18.36,
    height: 67.87,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2,167.12h-19.36V98.26h19.36v68.87Zm-18.36-1h17.36V99.26h-17.36v66.87Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.92,
    y: 74.81,
    width: 24.75,
    height: 91.81,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,167.12h-25.75V74.31h25.75v92.81Zm-24.75-1h23.75V75.31h-23.75v90.81Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.94,
    y: 80.93,
    width: 14.9,
    height: 85.69,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,167.12h-15.9V80.43h15.9v86.69Zm-14.9-1h13.9V81.43h-13.9v84.69Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.67,
    y: 207.78,
    width: 21.29,
    height: 73.21,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.46,281.49h-22.29v-74.21h22.29v74.21Zm-21.29-1h20.29v-72.21h-20.29v72.21Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 241.97,
    y: 211.26,
    width: 21.29,
    height: 69.73,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76,281.49h-22.29v-70.73h22.29v70.73Zm-21.29-1h20.29v-68.73h-20.29v68.73Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 263.26,
    y: 215.42,
    width: 21.29,
    height: 65.56,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.05,281.49h-22.29v-66.56h22.29v66.56Zm-21.29-1h20.29v-64.56h-20.29v64.56Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 284.55,
    y: 200.37,
    width: 23.16,
    height: 80.61,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2,281.49h-24.16v-81.61h24.16v81.61Zm-23.16-1h22.16v-79.61h-22.16v79.61Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.87,
    y: 260.76,
    width: 67.07,
    height: 20.23,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.43,281.49H124.37v-21.23h68.07v21.23Zm-67.07-1h66.07v-19.23H125.37v19.23Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.19,
    y: 322.87,
    width: 21.97,
    height: 72.75,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.66,396.12h-22.97v-73.75h22.97v73.75Zm-21.97-1h20.97v-71.75h-20.97v71.75Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.84,
    y: 329.97,
    width: 21.97,
    height: 65.64,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.3,396.12h-22.97v-66.64h22.97v66.64Zm-21.97-1h20.97v-64.64h-20.97v64.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 275.8,
    y: 329.97,
    width: 17.11,
    height: 65.64,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,396.12h-18.11v-66.64h18.11v66.64Zm-17.11-1h16.11v-64.64h-16.11v64.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.13,
    y: 340.73,
    width: 14.57,
    height: 54.89,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2,396.12h-15.57v-55.89h15.57v55.89Zm-14.57-1h13.57v-53.89h-13.57v53.89Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.16,
    y: 321.36,
    width: 19.65,
    height: 74.25,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.3,396.12h-20.65v-75.25h20.65v75.25Zm-19.65-1h18.65v-73.25h-18.65v73.25Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 242.01,
    y: 326.32,
    width: 11.83,
    height: 69.3,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.34,396.12h-12.83v-70.3h12.83v70.3Zm-11.83-1h10.83v-68.3h-10.83v68.3Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.37,
    y: 424.56,
    width: 21.97,
    height: 72.75,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.84,497.81h-22.97v-73.75h22.97v73.75Zm-21.97-1h20.97v-71.75h-20.97v71.75Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 230.18,
    y: 453.51,
    width: 65.64,
    height: 21.97,
    transform: "translate(-203.06 724.7) rotate(-89.66)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.28,497.88l-22.97-.14,.4-66.64,22.97,.14-.4,66.64Zm-21.96-1.13l20.97,.13,.39-64.64-20.97-.13-.39,64.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.98,
    y: 431.67,
    width: 17.11,
    height: 65.64,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.59,497.81h-18.11v-66.64h18.11v66.64Zm-17.11-1h16.11v-64.64h-16.11v64.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 291.31,
    y: 442.43,
    width: 14.57,
    height: 54.89,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,497.81h-15.57v-55.89h15.57v55.89Zm-14.57-1h13.57v-53.89h-13.57v53.89Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.34,
    y: 423.06,
    width: 19.65,
    height: 74.25,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.48,497.81h-20.65v-75.25h20.65v75.25Zm-19.65-1h18.65v-73.25h-18.65v73.25Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.19,
    y: 428.01,
    width: 11.83,
    height: 69.3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,497.81h-12.83v-70.3h12.83v70.3Zm-11.83-1h10.83v-68.3h-10.83v68.3Z",
    fill: "#002346"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 800.01,
    y: 120.48,
    width: 20.44,
    height: 434.72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.95,555.7h-21.45V119.98h21.45v435.72Zm-20.45-1h19.45V120.98h-19.45v433.72Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 795.7,
    y: 555.2,
    width: 29.05,
    height: 16.14,
    rx: 2.27,
    ry: 2.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.48,571.84h-24.51c-1.53,0-2.77-1.24-2.77-2.77v-11.6c0-1.53,1.24-2.77,2.77-2.77h24.51c1.53,0,2.77,1.24,2.77,2.77v11.6c0,1.53-1.24,2.77-2.77,2.77Zm-24.51-16.14c-.98,0-1.77,.79-1.77,1.77v11.6c0,.98,.79,1.77,1.77,1.77h24.51c.98,0,1.77-.79,1.77-1.77v-11.6c0-.98-.79-1.77-1.77-1.77h-24.51Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 795.7,
    y: 104.34,
    width: 29.05,
    height: 16.14,
    rx: 2.27,
    ry: 2.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.48,120.98h-24.51c-1.53,0-2.77-1.24-2.77-2.77v-11.6c0-1.53,1.24-2.77,2.77-2.77h24.51c1.53,0,2.77,1.24,2.77,2.77v11.6c0,1.53-1.24,2.77-2.77,2.77Zm-24.51-16.14c-.98,0-1.77,.79-1.77,1.77v11.6c0,.98,.79,1.77,1.77,1.77h24.51c.98,0,1.77-.79,1.77-1.77v-11.6c0-.98-.79-1.77-1.77-1.77h-24.51Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 545.52,
    y: 120.48,
    width: 20.44,
    height: 434.72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.47,555.7h-21.44V119.98h21.44v435.72Zm-20.44-1h19.44V120.98h-19.44v433.72Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 541.22,
    y: 555.2,
    width: 29.05,
    height: 16.14,
    rx: 2.27,
    ry: 2.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568,571.84h-24.51c-1.53,0-2.77-1.24-2.77-2.77v-11.6c0-1.53,1.24-2.77,2.77-2.77h24.51c1.53,0,2.77,1.24,2.77,2.77v11.6c0,1.53-1.24,2.77-2.77,2.77Zm-24.51-16.14c-.98,0-1.77,.79-1.77,1.77v11.6c0,.98,.79,1.77,1.77,1.77h24.51c.98,0,1.77-.79,1.77-1.77v-11.6c0-.98-.79-1.77-1.77-1.77h-24.51Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 541.22,
    y: 104.34,
    width: 29.05,
    height: 16.14,
    rx: 2.27,
    ry: 2.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568,120.98h-24.51c-1.53,0-2.77-1.24-2.77-2.77v-11.6c0-1.53,1.24-2.77,2.77-2.77h24.51c1.53,0,2.77,1.24,2.77,2.77v11.6c0,1.53-1.24,2.77-2.77,2.77Zm-24.51-16.14c-.98,0-1.77,.79-1.77,1.77v11.6c0,.98,.79,1.77,1.77,1.77h24.51c.98,0,1.77-.79,1.77-1.77v-11.6c0-.98-.79-1.77-1.77-1.77h-24.51Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565.97,
    y: 213.02,
    width: 234.04,
    height: 18.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.51,231.81h-235.04v-19.29h235.04v19.29Zm-234.04-1h233.04v-17.29h-233.04v17.29Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565.97,
    y: 314.16,
    width: 234.04,
    height: 18.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.51,332.96h-235.04v-19.29h235.04v19.29Zm-234.04-1h233.04v-17.29h-233.04v17.29Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565.97,
    y: 415.31,
    width: 234.04,
    height: 18.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.51,434.1h-235.04v-19.29h235.04v19.29Zm-234.04-1h233.04v-17.29h-233.04v17.29Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565.97,
    y: 505.7,
    width: 234.04,
    height: 18.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.51,524.49h-235.04v-19.29h235.04v19.29Zm-234.04-1h233.04v-17.29h-233.04v17.29Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 657.51,
    y: 132.99,
    width: 24.52,
    height: 79.71,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.53,213.2h-25.52v-80.71h25.52v80.71Zm-24.52-1h23.52v-78.71h-23.52v78.71Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 717.41,
    y: 140.77,
    width: 24.52,
    height: 71.93,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.44,213.2h-25.52v-72.93h25.52v72.93Zm-24.52-1h23.52v-70.93h-23.52v70.93Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 741.95,
    y: 140.77,
    width: 19.1,
    height: 71.93,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.55,213.2h-20.1v-72.93h20.1v72.93Zm-19.1-1h18.1v-70.93h-18.1v70.93Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 761.28,
    y: 152.56,
    width: 16.27,
    height: 60.14,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.05,213.2h-17.27v-61.14h17.27v61.14Zm-16.27-1h15.27v-59.14h-15.27v59.14Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 682.04,
    y: 131.34,
    width: 21.93,
    height: 81.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.47,213.2h-22.93v-82.36h22.93v82.36Zm-21.93-1h20.93v-80.36h-20.93v80.36Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 704.21,
    y: 136.77,
    width: 13.2,
    height: 75.94,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.91,213.2h-14.2v-76.94h14.2v76.94Zm-13.2-1h12.2v-74.94h-12.2v74.94Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 700.43,
    y: 249.17,
    width: 18.86,
    height: 64.87,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.8,314.54h-19.86v-65.87h19.86v65.87Zm-18.86-1h17.86v-63.87h-17.86v63.87Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 719.31,
    y: 252.25,
    width: 18.86,
    height: 61.79,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.67,314.54h-19.86v-62.79h19.86v62.79Zm-18.86-1h17.86v-60.79h-17.86v60.79Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 738.17,
    y: 255.94,
    width: 18.86,
    height: 58.1,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.53,314.54h-19.86v-59.1h19.86v59.1Zm-18.86-1h17.86v-57.1h-17.86v57.1Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 757.03,
    y: 242.61,
    width: 20.52,
    height: 71.44,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.05,314.54h-21.52v-72.44h21.52v72.44Zm-20.52-1h19.52v-70.44h-19.52v70.44Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 615.53,
    y: 296.12,
    width: 59.43,
    height: 17.93,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.46,314.54h-60.43v-18.93h60.43v18.93Zm-59.43-1h58.43v-16.93h-58.43v16.93Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 682.28,
    y: 351.16,
    width: 19.47,
    height: 64.47,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.25,416.12h-20.47v-65.47h20.47v65.47Zm-19.47-1h18.47v-63.47h-18.47v63.47Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 729.82,
    y: 357.45,
    width: 19.47,
    height: 58.17,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.78,416.12h-20.46v-59.17h20.46v59.17Zm-19.46-1h18.46v-57.17h-18.46v57.17Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 749.28,
    y: 357.45,
    width: 15.16,
    height: 58.17,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.95,416.12h-16.16v-59.17h16.16v59.17Zm-15.16-1h14.16v-57.17h-14.16v57.17Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 764.64,
    y: 366.98,
    width: 12.91,
    height: 48.64,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.05,416.12h-13.91v-49.64h13.91v49.64Zm-12.91-1h11.91v-47.64h-11.91v47.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 701.75,
    y: 349.82,
    width: 17.41,
    height: 65.8,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.66,416.12h-18.41v-66.8h18.41v66.8Zm-17.41-1h16.41v-64.8h-16.41v64.8Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 719.34,
    y: 354.21,
    width: 10.48,
    height: 61.41,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.32,416.12h-11.48v-62.41h11.48v62.41Zm-10.48-1h9.48v-60.41h-9.48v60.41Z",
    fill: "#002346"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 680.67,
    y: 441.27,
    width: 19.47,
    height: 64.47,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.63,506.24h-20.46v-65.47h20.46v65.47Zm-19.46-1h18.46v-63.47h-18.46v63.47Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.85,
    y: 466.92,
    width: 58.17,
    height: 19.47,
    transform: "translate(256.87 1211.72) rotate(-89.66)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.99,506.3l-20.46-.12,.35-59.17,20.46,.12-.35,59.17Zm-19.46-1.12l18.46,.11,.34-57.17-18.46-.11-.34,57.17Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 747.67,
    y: 447.57,
    width: 15.16,
    height: 58.17,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.33,506.24h-16.16v-59.17h16.16v59.17Zm-15.16-1h14.16v-57.17h-14.16v57.17Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 763.03,
    y: 457.1,
    width: 12.91,
    height: 48.64,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.44,506.24h-13.91v-49.64h13.91v49.64Zm-12.91-1h11.91v-47.64h-11.91v47.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 700.13,
    y: 439.94,
    width: 17.41,
    height: 65.8,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.04,506.24h-18.41v-66.8h18.41v66.8Zm-17.41-1h16.41v-64.8h-16.41v64.8Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 717.73,
    y: 444.33,
    width: 10.48,
    height: 61.41,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.71,506.24h-11.48v-62.41h11.48v62.41Zm-10.48-1h9.48v-60.41h-9.48v60.41Z",
    fill: "#002346"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 242.7,
    cy: 138.81,
    r: 11.22,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,150.53c-6.46,0-11.72-5.26-11.72-11.72s5.26-11.72,11.72-11.72,11.72,5.26,11.72,11.72-5.26,11.72-11.72,11.72Zm0-22.44c-5.91,0-10.72,4.81-10.72,10.72s4.81,10.72,10.72,10.72,10.72-4.81,10.72-10.72-4.81-10.72-10.72-10.72Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 253.34,
    cy: 147.15,
    r: 11.22,
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,158.87c-6.46,0-11.72-5.26-11.72-11.72s5.26-11.72,11.72-11.72,11.72,5.26,11.72,11.72-5.26,11.72-11.72,11.72Zm0-22.44c-5.91,0-10.72,4.81-10.72,10.72s4.81,10.72,10.72,10.72,10.72-4.81,10.72-10.72-4.81-10.72-10.72-10.72Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M303.16,603.92c-.98,3.47-1.34,7.08-1.08,10.68-1.75,1.1-2.87,4.66-2.87,4.66-1.48,3.22-4.1,3.08-6.09,2.34-1.45-.55-2.68-1.56-3.51-2.87-.64-.99-1.42-1.89-2.31-2.66l-.78-26.75,7.43,5c.7,.31,1.38,.57,2,.81,4,1.47,7.09,1.88,9.52,1.59-.4,2.5-1.18,4.93-2.31,7.2Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,622.54c-.73,0-1.53-.16-2.37-.47-1.54-.59-2.88-1.68-3.76-3.07-.61-.95-1.36-1.81-2.21-2.55l-.17-.14v-.22s-.82-27.72-.82-27.72l8.24,5.54c.56,.24,1.17,.48,1.75,.7l.16,.06c3.63,1.33,6.76,1.86,9.28,1.56l.66-.08-.11,.65c-.41,2.54-1.2,5-2.33,7.3-.95,3.41-1.31,6.93-1.05,10.46l.02,.3-.25,.16c-1.57,.99-2.65,4.35-2.66,4.39-.95,2.07-2.46,3.13-4.37,3.13Zm-7.52-6.7c.86,.77,1.61,1.65,2.24,2.62,.77,1.21,1.93,2.16,3.27,2.67,2.54,.95,4.39,.25,5.46-2.08,.02-.09,1.07-3.37,2.81-4.7-.23-3.57,.15-7.12,1.12-10.57l.03-.09c1.01-2.03,1.73-4.19,2.15-6.42-2.57,.17-5.55-.38-9.09-1.68l-.16-.06c-.58-.23-1.22-.47-1.87-.76l-6.7-4.5,.75,25.56Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.45,632.71c-.78,1.21-1.02,2.69-.67,4.08,.36,1.07,1.37,1.78,2.5,1.76h18.94c1.05,.01,2.01-.61,2.43-1.58,.46-1.4,.21-2.94-.67-4.12l-22.53-.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.23,639.05c-1.32,0-2.49-.84-2.92-2.1-.4-1.56-.13-3.19,.72-4.51l.15-.23,23.05,.14,.15,.2c.98,1.31,1.26,3.02,.75,4.58-.51,1.2-1.63,1.93-2.91,1.92h-18.93s-.04,0-.06,0Zm-1.49-5.84c-.59,1.04-.76,2.29-.47,3.46,.28,.83,1.12,1.43,2.01,1.38h18.95c.82,0,1.63-.49,1.97-1.28,.37-1.13,.2-2.4-.47-3.42l-21.99-.14Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.95,
    y: 592.09,
    width: 15.78,
    height: 30.25,
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.22,622.84h-16.78v-31.25h16.78v31.25Zm-15.78-1h14.78v-29.25h-14.78v29.25Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.11,354.17s0,2.51-.16,6.84c-.47,16.81-2.24,61.14-8.16,92.52,0,0-8.75,52.16-12.25,80.22,0,0-5.69,32.87-7.44,50.41,0,0,.78,11.39-8.61,12.48-2.43,.29-5.54-.12-9.52-1.59-.65-.24-1.33-.5-2-.81l-7.43-5-.46-.3s-4.95,14.85-28.07,4.53c-1.33-.58-2.23-1.85-2.32-3.3-.68-14.65-4.33-95.18-4-138.87,.11-12.27,.52-21.64,1.41-25.82l19.7-62.43s52.24,.12,69.31-8.88Z",
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5,597.63c-4.25,0-9.16-1.24-14.69-3.7-1.51-.65-2.51-2.08-2.61-3.72-.73-15.62-4.33-95.69-4-138.91,.12-13.52,.58-22,1.42-25.92l19.82-62.83h.37c.47-.01,52.31,.02,69.08-8.82l.73-.39v.83s0,2.57-.16,6.86c-.49,17.4-2.26,61.25-8.17,92.59-.09,.51-8.79,52.46-12.25,80.19-.06,.35-5.71,33.08-7.44,50.4,0,.03,.7,11.79-9.05,12.93-2.69,.32-5.97-.22-9.75-1.62-.61-.23-1.32-.5-2.04-.83l-7.45-5c-.61,1.35-2.49,4.66-6.81,6.56-2.08,.92-4.43,1.38-7.02,1.38Zm.67-234.08l-19.59,62.08c-.8,3.76-1.27,12.41-1.39,25.67-.33,43.19,3.27,123.24,4,138.84,.08,1.26,.85,2.36,2.02,2.86,8.61,3.84,15.63,4.63,20.87,2.33,5-2.19,6.51-6.52,6.52-6.57l.21-.61,1,.65,7.44,5c.61,.28,1.3,.54,1.89,.76,3.63,1.34,6.75,1.86,9.29,1.56,8.8-1.02,8.2-11.5,8.17-11.95,1.73-17.44,7.39-50.2,7.45-50.53,3.46-27.73,12.16-79.7,12.25-80.22,5.9-31.28,7.67-75.08,8.15-92.45,.11-2.86,.14-4.94,.15-6.01-17.07,8.29-63.44,8.56-68.44,8.56Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.79,209.17s-13.15,3.06-19.28-4.39l1.75-13.15,4,.74,14.85,2.8c-1.14,2.99-1.77,6.16-1.85,9.36-.03,1.56,.15,3.12,.53,4.64Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.58,210.31c-4.35,0-9.95-.96-13.45-5.21l-.14-.17,1.85-13.89,19.96,3.75-.21,.56c-1.12,2.95-1.74,6.04-1.82,9.19-.03,1.52,.14,3.03,.51,4.5l.13,.49-.5,.12c-.24,.06-2.9,.65-6.33,.65Zm-12.54-5.68c5.25,6.13,15.75,4.6,18.15,4.15-.31-1.4-.45-2.83-.42-4.26,.08-3.07,.64-6.08,1.68-8.97l-17.75-3.33-1.65,12.41Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M630.59,635.65s-38.82,.78-39.89,0c-4.82-3.48,5.3-10.48,5.3-10.48,5.26-4.39,3.64-8.57,3.64-8.57v-.15c.96,.16,1.95,.16,2.91,0,0,0,2.39,.08,6,.53,6.04,.67,11.97,2.08,17.66,4.19,.73,.51,1.55,.89,2.42,1.12v.12c4.27,5.19,1.96,13.24,1.96,13.24Z",
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.59,636.5c-6.63,0-11.73-.11-12.19-.45-1.01-.73-1.52-1.66-1.51-2.76,.04-3.8,6.54-8.34,6.82-8.53,4.86-4.06,3.52-7.82,3.46-7.98l-.03-.18v-.74l.58,.1c.91,.16,1.83,.16,2.74,0h.05s.05,0,.05,0c.02,0,2.45,.09,6.04,.53,6.06,.67,12.05,2.09,17.77,4.22l.11,.06c.69,.48,1.45,.83,2.26,1.05l.37,.1v.33c4.23,5.33,2.04,13.22,1.94,13.55l-.1,.35h-.37c-6.8,.14-18.86,.36-28.01,.36Zm-2.32-19.46c.27,1.39,.39,4.89-3.95,8.52-1.8,1.25-6.39,5.02-6.42,7.75,0,.77,.35,1.41,1.09,1.94,1.33,.47,24.04,.21,39.21-.09,.37-1.58,1.6-8.11-1.95-12.43l-.03-.04c-.8-.24-1.55-.6-2.24-1.08-5.63-2.09-11.51-3.48-17.48-4.14-3.27-.41-5.56-.51-5.91-.53-.77,.13-1.54,.15-2.31,.08Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.19,634.81s-2.2-12.28,14-14.47c0,0,14.46-1.76,16.22-4.39l32.84,6.81s1.35,6.77,.48,12l-63.54,.05Z",
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.77,635.31l-.07-.41c-.03-.19-.81-4.74,2.22-8.9,2.42-3.32,6.52-5.39,12.2-6.16,5.73-.7,14.67-2.38,15.87-4.17l.19-.28,33.49,6.95,.06,.32c.06,.28,1.36,6.92,.48,12.18l-.07,.42-64.38,.05Zm30.83-18.81c-2.49,2.58-14.9,4.16-16.35,4.34-5.39,.73-9.26,2.66-11.51,5.74-2.28,3.12-2.21,6.56-2.1,7.73l62.67-.05c.62-4.37-.24-9.72-.48-11.08l-32.22-6.68Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M661.74,320.69s-11.48,113.32-14.1,172.93c-2.62,59.61-11.8,119.23-11.8,119.23-.85,9.37-4.65,10.1-7.22,9.45-.87-.23-1.69-.61-2.42-1.12-5.7-2.15-11.64-3.58-17.69-4.28-3.6-.45-6-.53-6-.53-.96,.16-1.95,.16-2.91,0-8.8-1.44-1.47-19.78-1.47-19.78,2.92-4.09,3.11-8.95,2.91-11.73-.17-2.36-.29-4.73-.28-7.09l.06-30.24h0l.33-157.35-26.27,123.19c-1.82,12.65-4.28,25.2-7.36,37.6-4.27,16.82-8.4,26.76-10.63,31.44-1.06,2.23-1.83,4.58-2.24,7.02-1.84,10.97-4.73,12.06-4.73,12.06-5.7,6.57-2.19,16.22-2.19,16.22,1.6,15.25-16.41,8.16-26.42,3.1-3.81-1.91-6.45-3.54-6.45-3.54-1.76-6.13,2.18-18,2.18-18,3.51-5.7-.87-8.33-.87-8.33-4.83-3.06,.87-15.78,.87-15.78,4.82-14.46,17.51-100.38,17.51-100.38,8.6-44.22,17-129.89,19.31-153.83,.39-4.07,.6-6.35,.6-6.35l55-11.67,52.28,17.77Z",
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.37,627.45c-5.62,0-13.18-3.11-19.28-6.2-3.78-1.9-6.46-3.54-6.49-3.56l-.16-.1-.05-.19c-1.78-6.21,2.02-17.81,2.19-18.3l.05-.1c1.12-1.82,1.52-3.49,1.16-4.96-.43-1.79-1.85-2.67-1.87-2.68-5.15-3.26,.43-15.88,.67-16.41,4.73-14.21,17.34-99.39,17.47-100.25,7.71-39.64,15.41-113.38,19.31-153.8,.39-4.07,.6-6.35,.6-6.35l.03-.37,55.49-11.77,.13,.04,52.66,17.9-.04,.4c-.11,1.13-11.51,113.99-14.1,172.9-2.59,58.96-11.71,118.69-11.81,119.28-.42,4.68-1.65,7.79-3.64,9.19-1.18,.83-2.63,1.06-4.2,.67-.91-.24-1.76-.63-2.53-1.16-5.64-2.12-11.53-3.54-17.51-4.23-3.26-.41-5.55-.51-5.91-.53-1.01,.17-2.02,.16-3.03,0-1.67-.27-2.92-1.13-3.72-2.54-3.06-5.42,1.67-17.41,1.87-17.92l.06-.1c2.87-4.03,3-8.88,2.82-11.41-.2-2.85-.29-5.05-.29-7.13l.38-182.8-25.27,118.51c-1.81,12.57-4.29,25.24-7.36,37.62-4.33,17.06-8.54,27.08-10.67,31.54-1.07,2.24-1.81,4.56-2.2,6.89-1.68,10.01-4.24,12.02-4.91,12.38-5.34,6.27-2.06,15.55-2.03,15.64l.03,.12c.43,4.07-.49,6.91-2.73,8.46-1.36,.94-3.13,1.34-5.14,1.34Zm-25.07-10.51c.64,.38,3.03,1.81,6.24,3.42,6.58,3.33,18.38,8.39,23.4,4.93,1.9-1.31,2.68-3.83,2.31-7.47-.32-.91-3.35-10.14,2.3-16.66l.08-.1,.12-.04s2.67-1.32,4.41-11.67c.41-2.42,1.17-4.82,2.29-7.15,2.11-4.42,6.29-14.38,10.6-31.35,3.07-12.34,5.54-24.97,7.35-37.55l27.28-127.91-.4,192.38c0,2.05,.08,4.23,.28,7.06,.19,2.65,.05,7.74-2.97,12.01-.34,.88-4.64,12.16-1.91,17,.65,1.15,1.64,1.82,3.01,2.05,.91,.16,1.84,.16,2.74,0h.05s.05,0,.05,0c.02,0,2.46,.09,6.05,.53,6.08,.7,12.07,2.15,17.8,4.31l.11,.06c.69,.48,1.45,.83,2.26,1.05,1.29,.33,2.43,.15,3.37-.51,1.74-1.23,2.82-4.09,3.22-8.5,.1-.63,9.21-60.31,11.8-119.21,2.51-57.18,13.32-165.13,14.06-172.56l-51.77-17.6-54.51,11.56c-.07,.8-.27,2.86-.57,5.99-3.9,40.45-11.6,114.22-19.32,153.88-.12,.84-12.75,86.11-17.53,100.44-1.55,3.48-4.74,12.88-1.08,15.2,.06,.04,1.77,1.09,2.31,3.28,.42,1.72,0,3.63-1.25,5.68-.28,.86-3.72,11.71-2.21,17.46Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M698.89,286.71c-4.13,4-11.83,4.39-11.83,4.39-14.91,1.32-21.48,1.76-21.48,1.76l1.32,18c1.76,25.86-74.95,17.55-74.95,17.55-17.54,0-35.51-11.83-35.51-11.83-6.91-3.62-4.94-13.62-3.52-18.4,.68-2.28,1.22-4.61,1.52-6.97,2.72-21.48-1.52-37.27-1.52-37.27-4.01,11.23-10.27,21.52-18.41,30.23-2.18,1.79-5.36,2.54-9.17,2.52-18.61-.09-52.48-18.41-61.11-23.25-.78-.44-1.06-1.44-.62-2.22,.09-.15,.2-.29,.33-.41,6.41-5.95,8.39-15.2,9-19.28,.13-.89,.94-1.5,1.83-1.38,.13,.02,.25,.05,.37,.1l16,6.24c13.15-3.51,15.78,.43,15.78,.43,6.57,5.7,10.08,2.19,10.08,2.19,4.82-21,30.23-85.48,30.23-85.48,7.88-21.92,44.7-18.86,44.7-18.86l37.7,2.62c6.57,1.75,18.85,3.06,18.85,3.06,27.61,3.5,34.64,34.62,34.64,34.62,10.52,23.67,21,67.5,21,67.5,5.73,25.81-5.23,34.14-5.23,34.14Z",
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.04,330.22c-13.68,0-25.11-1.2-26.14-1.31h0c-17.43,0-35.54-11.79-35.73-11.91-7.3-3.82-5.04-14.53-3.73-18.96,.74-2.51,1.24-4.76,1.51-6.89,2.18-17.24-.17-30.91-1.13-35.46-4.06,10.73-10.08,20.42-17.94,28.82-2.2,1.81-5.37,2.73-9.54,2.68-18.52-.09-51.64-17.87-61.35-23.31-.5-.28-.85-.74-1.01-1.28-.15-.55-.08-1.12,.2-1.62,.11-.2,.26-.38,.43-.53,6.07-5.63,8.14-14.31,8.84-18.98,.08-.56,.37-1.05,.82-1.39,.45-.34,1.01-.48,1.57-.41,.17,.02,.33,.07,.48,.13l15.85,6.18c12.44-3.29,15.69,.07,16.12,.61,5.56,4.8,8.67,2.75,9.26,2.27,4.86-20.96,29.96-84.75,30.22-85.4,7.91-22.01,44.84-19.21,45.21-19.18l37.69,2.62c6.55,1.74,18.75,3.05,18.87,3.06,27.65,3.5,35,34.69,35.08,35.01,10.39,23.35,20.89,67.06,21,67.49,5.66,25.47-4.66,34.07-5.39,34.63-4.22,4.07-11.81,4.49-12.13,4.51-12.47,1.1-19.17,1.6-20.97,1.72l1.28,17.5c.25,3.68-1.03,6.9-3.8,9.56-8.33,8-28.65,9.84-45.56,9.84Zm-65.05-77.96l.42,1.55c.04,.16,4.23,16.14,1.53,37.46-.28,2.19-.78,4.49-1.54,7.05-1.24,4.19-3.41,14.31,3.27,17.81,.22,.14,18.1,11.77,35.28,11.77,.61,.06,56.23,5.91,70.96-8.25,2.55-2.45,3.72-5.4,3.5-8.77l-1.36-18.5,.5-.03c.07,0,6.74-.45,21.47-1.76,.09,0,7.58-.43,11.53-4.25l.04-.04c.11-.08,10.63-8.49,5.05-33.63-.1-.43-10.59-44.05-20.97-67.41-.1-.4-7.31-30.91-34.25-34.33-.11-.01-12.38-1.33-18.92-3.07l-37.61-2.6c-.37-.03-36.54-2.77-44.19,18.53-.26,.66-25.46,64.7-30.21,85.42l-.03,.14-.1,.1c-.16,.16-3.92,3.77-10.76-2.17l-.09-.1s-2.73-3.56-15.24-.22l-.16,.04-16.15-6.3c-.08-.03-.17-.06-.26-.07-.3-.04-.59,.04-.83,.21-.24,.18-.39,.44-.44,.74-.72,4.81-2.86,13.73-9.16,19.58-.1,.09-.17,.18-.23,.29-.15,.26-.19,.57-.11,.86,.08,.29,.27,.53,.53,.68,9.66,5.42,42.59,23.1,60.87,23.19,.05,0,.1,0,.14,0,3.83,0,6.76-.81,8.71-2.41,8.09-8.67,14.25-18.78,18.26-30.01l.54-1.51Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 590.7,
    y: 635.65,
    width: 39.89,
    height: 2.63,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.09,638.78h-40.89v-3.63h40.89v3.63Zm-39.89-1h38.89v-1.63h-38.89v1.63Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 484.19,
    y: 634.8,
    width: 63.56,
    height: 3.51,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.25,638.81h-64.56v-4.51h64.56v4.51Zm-63.56-1h62.56v-2.51h-62.56v2.51Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M635.29,284.49l-17.94,6.68c-2.42,.56-4.93,.68-7.39,.35-3.44-.45-6.75-1.62-9.71-3.42-6.13-2.63-5.7-5.7-5.7-5.7-3.5-1.75-3.94-7-3.94-7-2.3-1.34-4.15-3.33-5.31-5.7-.34-.69-.34-1.53,.16-2.11,1.76-2.02,6.45,1.67,6.45,1.67,3.68,2.58,8.09,3.11,10.75,3.16,1.43,.03,2.84-.36,4.06-1.1l6.23-3.8c4.82-3.51-.44-3.07-.44-3.07-5.67,.74-8,.23-9-.35-.54-.35-.73-1.04-.46-1.62,1.87-4,14.62-3.67,19.43-3.42,1.18,.07,2.34,.38,3.39,.92l11,5.66c.62,9.24-.38,11.24-1.58,18.86Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.69,292.21c-.93,0-1.86-.06-2.79-.19-3.53-.47-6.86-1.64-9.9-3.49-5.2-2.22-5.88-4.87-5.94-5.83-3.05-1.74-3.77-5.9-3.91-7-2.29-1.39-4.11-3.38-5.29-5.79-.45-.93-.36-1.97,.24-2.66,2.01-2.31,6.62,1.2,7.13,1.61,3.45,2.42,7.59,3,10.45,3.05,1.3,.04,2.65-.33,3.79-1.03l6.23-3.8c1.87-1.36,1.79-1.86,1.79-1.86-.07-.19-.99-.36-1.93-.28-4.63,.6-7.77,.47-9.29-.42-.76-.5-1.04-1.46-.66-2.27,1.88-4.03,13.28-4.05,19.91-3.71,1.26,.07,2.47,.4,3.59,.97l11.25,5.79,.02,.28c.49,7.29-.01,10.07-.85,14.68-.23,1.25-.48,2.64-.74,4.29l-.05,.29-18.21,6.78c-1.62,.38-3.23,.56-4.84,.56Zm-25.76-24.71c-.44,0-.82,.12-1.08,.43-.33,.38-.37,.99-.09,1.56,1.13,2.3,2.9,4.2,5.12,5.49l.22,.13,.02,.26s.46,4.99,3.67,6.59l.32,.16-.05,.36s-.23,2.75,5.4,5.17c2.98,1.81,6.19,2.94,9.58,3.38,2.41,.32,4.84,.21,7.21-.34l17.61-6.56c.25-1.54,.48-2.84,.7-4.03,.81-4.47,1.3-7.19,.85-14.15l-10.75-5.53c-1-.51-2.07-.8-3.19-.87-10.69-.56-17.77,.62-18.95,3.13-.17,.35-.05,.78,.28,.99,.89,.52,3.14,.99,8.66,.27,.61-.05,2.58-.13,2.97,.93,.3,.79-.38,1.73-2.17,3.04l-6.26,3.83c-1.31,.8-2.77,1.21-4.33,1.18-3-.06-7.34-.67-11.03-3.25-.89-.7-3.17-2.18-4.7-2.18Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.52,426.4c-2.36,2.35-2.39,6.26-2.27,7.95,0,.29-.22,.53-.5,.54-.1,0-.2-.02-.29-.08-1.09-1-1.84-2.31-2.17-3.75-.04-.17-.21-.27-.38-.22-.13,.03-.23,.15-.23,.28-.59,6.53-2.05,5.8-2.05,5.8-3.07,.44-3.51-6.57-3.51-6.57-3.51-1.32-3.51-3.95-3.51-3.95-2.03-1.21-3.34-3.34-3.51-5.7-4.38-2.19-2.94-17.33-2.94-17.33v-.15c4.06,3,15.66,11,24.35,12.25-.14,3.83-1.16,7.57-2.99,10.93Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76,437.45c-.06,0-.12,0-.17-.02-.62,.06-1.19-.12-1.7-.53-1.67-1.36-2.14-5.08-2.25-6.2-2.87-1.2-3.41-3.24-3.51-4.01-1.97-1.27-3.26-3.36-3.51-5.69-4.26-2.66-3.11-16.13-2.96-17.68v-1.09s.79,.59,.79,.59c3.42,2.53,15.28,10.89,24.12,12.16l.44,.06-.02,.45c-.14,3.88-1.19,7.74-3.05,11.15l-.09,.12c-2.24,2.23-2.23,6.03-2.12,7.56,.02,.58-.43,1.05-.99,1.07-.22,0-.39-.05-.56-.15-.99-.9-1.69-1.95-2.12-3.12-.35,3.01-.94,4.71-1.81,5.19-.18,.1-.36,.14-.51,.14Zm-13.17-33.29c-.35,4.62-.42,14.52,2.73,16.1l.25,.13,.02,.28c.16,2.2,1.38,4.18,3.27,5.31l.24,.15v.28c0,.09,.07,2.31,3.19,3.48l.3,.11,.02,.32c.08,1.25,.58,4.73,1.91,5.81,.32,.26,.65,.35,1.03,.3l.16-.02,.06,.03c.15-.08,.99-.74,1.4-5.36,.02-.34,.26-.64,.61-.72,.21-.05,.43-.02,.61,.09,.19,.11,.32,.29,.37,.5,.31,1.36,1.01,2.57,2.02,3.5-.17-1.71-.17-5.81,2.32-8.34,1.69-3.13,2.68-6.65,2.88-10.2-8.45-1.42-19.27-8.75-23.4-11.74Zm15.58,26.99s0,0,0,.01c0,0,0,0,0-.01Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.13,634.64c-.89-.01-1.73-.41-2.31-1.09-.67-.82-.95-2.1,.95-3.76,0,0,2.19-1.32,0-4,0,0-2.43-7.58,4.07-11.14,3.33-1.88,7.39-1.93,10.78-.15,2.35,1.28,4.76,3.68,5.75,8.22v8.77s3.07,3.94-4.82,3.5l-14.42-.35Z",
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.72,635.53c-.38,0-.78-.01-1.2-.04l-14.4-.35c-1.03-.02-2.01-.48-2.68-1.27-.64-.79-1.36-2.4,1-4.46,.07-.05,.67-.43,.78-1.14,.1-.63-.18-1.36-.84-2.17l-.09-.16c-.03-.08-2.48-8.02,4.31-11.73,3.49-1.97,7.7-2.02,11.25-.15,3.12,1.7,5.14,4.58,6,8.56v.11s.01,8.61,.01,8.61c.27,.41,.92,1.57,.37,2.63-.55,1.05-2.03,1.57-4.52,1.57Zm-16.5-9.97c.81,1.02,1.14,2,.99,2.91-.2,1.16-1.14,1.74-1.18,1.76-1.91,1.68-1.09,2.69-.82,3.02,.48,.56,1.18,.9,1.93,.91h0l14.42,.35c3.62,.2,4.55-.54,4.79-1,.37-.7-.37-1.69-.38-1.7l-.11-.14v-8.89c-.81-3.66-2.66-6.29-5.49-7.84-3.24-1.71-7.1-1.65-10.3,.15-5.77,3.16-4.12,9.61-3.87,10.47Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.99,638.1l-45.15,.45-.44-4.38s-.06-.78-.12-2c-.24-4.8-.57-16.57,1.87-17.27,.79,.22,1.52,.62,2.11,1.19,.89,.77,1.67,1.67,2.31,2.66,.83,1.31,2.06,2.32,3.51,2.87,2,.74,4.61,.88,6.09-2.34,0,0,1.12-3.56,2.87-4.66,.76-.51,1.77-.39,2.39,.27,0,0,6.14,9.65,15.79,14.46,0,0,6.23,.94,8.19,5.69,.39,.97,.59,2.01,.58,3.06Z",
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,639.06l-.48-4.83s-.06-.8-.12-2.03c-.56-11.21,.19-17.19,2.23-17.77l.13-.04,.13,.04c.87,.24,1.67,.69,2.32,1.31,.91,.79,1.72,1.72,2.38,2.75,.77,1.21,1.93,2.16,3.27,2.68,2.55,.94,4.39,.25,5.46-2.08,.03-.09,1.17-3.69,3.06-4.87,.95-.64,2.23-.49,3.02,.35,.12,.17,6.21,9.62,15.58,14.32,.79,.13,6.55,1.27,8.5,5.98,.42,1.04,.62,2.14,.62,3.25v.49s-46.1,.46-46.1,.46Zm1.79-23.63c-1.1,.63-1.94,5.96-1.4,16.72,.06,1.21,.12,1.98,.12,1.99l.39,3.91,44.19-.44c-.05-.82-.23-1.61-.53-2.38-1.83-4.42-7.74-5.37-7.8-5.38l-.15-.05c-9.66-4.82-15.93-14.54-15.99-14.64-.4-.41-1.14-.49-1.69-.12-1.58,1-2.66,4.36-2.67,4.4-1.31,2.86-3.7,3.78-6.74,2.66-1.54-.59-2.88-1.68-3.76-3.07-.62-.95-1.36-1.81-2.22-2.55-.51-.48-1.11-.84-1.75-1.04Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.99,638.1l-45.15,.45-.44-4.38s-.06-.78-.12-2c5.08,2.62,10.64,4.2,16.34,4.64,0,0,21.46,1.5,28.79-1.77,.39,.97,.59,2.01,.58,3.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,639.06l-.48-4.83s-.06-.8-.12-2.03l-.04-.87,.77,.4c5.05,2.6,10.49,4.14,16.15,4.59,.21,.01,21.42,1.45,28.55-1.73l.48-.21,.19,.48c.42,1.04,.62,2.13,.62,3.25v.49s-46.1,.46-46.1,.46Zm.44-6.05c.04,.7,.07,1.12,.07,1.13l.39,3.91,44.19-.44c-.04-.65-.16-1.28-.36-1.9-7.75,3.02-27.67,1.67-28.53,1.61-5.51-.43-10.81-1.88-15.76-4.31Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379.77,254.54c4.6-3.91,8.59-8.49,11.83-13.59l6.58-9.21s3.5,4-2.19,13.15c0,0,.88,2.63,8.33-.44l19.84-9.93c.72-.35,1.57-.21,2.14,.35h0c.72,.72,.72,1.89,0,2.62-.11,.11-.23,.2-.37,.28l-11.78,6.93c-.53,.31-.7,.98-.4,1.5,.02,.04,.05,.08,.08,.12h0c.33,.44,.93,.57,1.41,.31l11.46-6.09c.97-.51,2.18-.19,2.76,.74h0c.61,.98,.32,2.27-.66,2.88-.03,.02-.05,.03-.08,.05l-12.4,7.09c-.6,.35-.85,1.08-.6,1.72h0c.25,.62,.91,.98,1.57,.84l16.2-3.32c1.08-.23,2.14,.45,2.38,1.53,0,0,0,0,0,0h0c.25,1.08-.42,2.15-1.49,2.4-.03,0-.05,.01-.08,.02l-18.46,3.77c-.58,.12-1,.63-1,1.23h0c0,.66,.51,1.2,1.17,1.24l10.45,.68c.88,.06,1.54,.82,1.48,1.69,0,.1-.02,.21-.05,.31h0c-.2,.69-.83,1.16-1.55,1.15-4.16,0-17.81,0-21.14,2.22,0,0-3.07,2.19-8.77,2.19,0,0-4.38,.44-4.82,3.07l-9.62-3.88-2.22-13.63Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.01,272.75l-10.46-4.22-2.31-14.19,.21-.18c4.57-3.88,8.52-8.42,11.73-13.48l6.96-9.75,.42,.48c.15,.17,3.61,4.3-1.97,13.47,.4,.41,2.02,1.38,7.55-.9l19.81-9.92c.91-.44,2-.26,2.71,.44,.45,.45,.69,1.04,.69,1.67,0,.63-.25,1.22-.69,1.66-.14,.14-.3,.26-.47,.36l-11.78,6.93c-.29,.17-.39,.54-.22,.82,.22,.31,.55,.38,.82,.24l11.46-6.09c1.19-.63,2.7-.23,3.42,.92,.37,.59,.49,1.28,.33,1.95-.15,.67-.56,1.25-1.15,1.62l-.11,.06-12.39,7.09c-.38,.22-.55,.69-.38,1.1,.16,.39,.58,.62,1,.53l16.2-3.32c1.34-.29,2.67,.57,2.97,1.92,.31,1.34-.52,2.69-1.86,3l-.1,.02-18.45,3.77c-.35,.07-.6,.38-.6,.74,0,.4,.31,.72,.7,.74l10.45,.68c1.15,.08,2.02,1.07,1.95,2.22,0,.14-.03,.27-.07,.41-.26,.91-1.06,1.56-2.04,1.52-11.71,0-18.73,.72-20.86,2.14-.12,.08-3.25,2.27-9.05,2.27,.01,0-3.96,.43-4.33,2.65l-.1,.61Zm-9.56-4.94l8.84,3.57c.96-2.45,4.92-2.88,5.1-2.9,5.53,0,8.5-2.08,8.53-2.1,3.47-2.31,16.99-2.31,21.43-2.31h.02c.49,0,.92-.32,1.05-.79,.02-.06,.03-.13,.03-.2,.04-.6-.42-1.12-1.02-1.16l-10.45-.68c-.92-.05-1.64-.82-1.64-1.74,0-.83,.59-1.55,1.4-1.72l18.46-3.77c.87-.2,1.37-1.01,1.18-1.82-.18-.82-.97-1.34-1.79-1.17l-16.21,3.32c-.9,.19-1.79-.3-2.13-1.14-.34-.88,0-1.87,.81-2.34l12.4-7.09c.42-.26,.67-.62,.77-1.03s.02-.84-.2-1.2c-.44-.71-1.37-.95-2.1-.56l-11.46,6.09c-.69,.38-1.57,.18-2.05-.45-.04-.05-.08-.11-.11-.16-.44-.76-.18-1.74,.58-2.19l11.78-6.93c.1-.06,.19-.13,.27-.21,.25-.25,.4-.59,.4-.95,0-.36-.14-.7-.4-.96-.41-.4-1.04-.51-1.57-.25l-19.83,9.93c-3.69,1.52-6.35,1.92-7.94,1.19-.85-.39-1.07-.98-1.09-1.04l-.07-.22,.12-.2c4.21-6.77,3.23-10.6,2.58-11.98l-6.14,8.59c-3.21,5.04-7.14,9.59-11.7,13.5l2.13,13.07Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M591.9,129.37v15.35s-1.31,18,18.42,18.4c0,0,15.78-1.32,19.28-15.78-3.49-1.52-5.73-4.97-5.7-8.77l-.9-25.86-31.1,16.66Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.36,163.62c-6.32-.12-11.16-2.01-14.43-5.61-5.03-5.52-4.55-13.01-4.53-13.32v-15.61s32.07-17.18,32.07-17.18l.93,26.66c-.03,3.63,2.09,6.89,5.4,8.33l.39,.17-.1,.41c-3.54,14.64-19.56,16.15-19.72,16.16Zm-17.96-33.95v15.05c0,.11-.47,7.42,4.27,12.62,3.09,3.38,7.68,5.16,13.66,5.28,.1-.01,15.12-1.44,18.68-15-3.46-1.68-5.65-5.19-5.61-9.05l-.87-25.04-30.13,16.14Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M600.44,62.74h0c11.98,0,21.7,9.72,21.7,21.7v29.36c0,11.98-9.72,21.7-21.7,21.7h0c-11.98,0-21.7-9.72-21.7-21.7v-29.36c0-11.98,9.72-21.7,21.7-21.7Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.43,136c-12.24,0-22.2-9.96-22.2-22.2v-29.36c0-12.24,9.96-22.2,22.2-22.2s22.2,9.96,22.2,22.2v29.36c0,12.24-9.96,22.2-22.2,22.2Zm0-72.76c-11.69,0-21.2,9.51-21.2,21.2v29.36c0,11.69,9.51,21.2,21.2,21.2s21.2-9.51,21.2-21.2v-29.36c0-11.69-9.51-21.2-21.2-21.2Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M584.86,68.01s-8.77,0-7.45,7c0,0,6.58,13.15,36.82,3.06,0,0-2.63,11.4,1.76,17.1,0,0-3.12,8.46,4.36,9.71l9.67,6.07-5.7,8.32s.88,7,7,3.51c0,0,3.5-2.63,2.62-12.27,0,0,4.39-1.32,.88-9.21,0,0,11.83-6.14,2.62-15.34,0,0,1.75-15.78-12.71-12.27,0,0-.44-14-13.59-9.2,0,0-4.39-15.35-16.22-9.21,0,0-3.51,1.76-2.63,7.9,.02,0-6.56-3.01-7.43,4.83Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.24,124.26c-.6,0-1.16-.13-1.67-.38-2.29-1.15-2.72-4.4-2.74-4.54l-.02-.19,5.51-8.05-9.15-5.74c-2.09-.37-3.59-1.32-4.46-2.82-1.56-2.69-.59-6.28-.27-7.27-3.62-5-2.38-13.68-1.86-16.44-29.61,9.61-36.33-3.03-36.61-3.58l-.04-.13c-.37-1.97-.02-3.62,1.03-4.89,1.83-2.21,5.25-2.61,6.47-2.68,.6-4.18,2.87-5.25,4.7-5.4,.71-.06,1.78,.07,2.59,.3-.51-5.76,2.85-7.52,3-7.59,3.26-1.69,6.3-1.96,9.02-.79,4.83,2.08,7.15,8.01,7.75,9.8,3.81-1.29,6.95-1.13,9.32,.48,3.48,2.36,4.24,7.07,4.4,8.75,4-.86,7.14-.31,9.35,1.63,3.82,3.36,3.53,9.73,3.42,11.07,2.68,2.74,3.83,5.51,3.41,8.22-.63,4.09-4.6,6.75-5.91,7.52,1.33,3.13,1.58,5.63,.75,7.44-.5,1.09-1.28,1.63-1.74,1.87,.78,9.51-2.7,12.24-2.85,12.36-1.26,.72-2.38,1.07-3.39,1.07Zm-3.39-4.87c.12,.64,.62,2.82,2.17,3.59,1.05,.52,2.41,.31,4.06-.63h0s3.21-2.64,2.37-11.79l-.04-.41,.39-.12s.98-.32,1.52-1.52c.5-1.11,.73-3.22-.95-7l-.19-.43,.42-.22c.05-.03,5.13-2.72,5.79-7.02,.38-2.44-.73-4.97-3.29-7.52l-.17-.17,.03-.24c0-.07,.73-7.11-3.07-10.45-2.05-1.8-5.09-2.24-9.02-1.28l-.6,.15-.02-.61c0-.06-.24-6.01-4.01-8.55-2.2-1.48-5.2-1.55-8.91-.19l-.5,.18-.15-.52c-.02-.07-2.19-7.44-7.35-9.66-2.43-1.04-5.18-.79-8.16,.76-.13,.07-3.18,1.71-2.37,7.39l-.5,.07-.23,.44s-2.46-1.12-4.39-.06c-1.28,.7-2.05,2.21-2.3,4.5l-.05,.44h-.45s-4.23,.03-6.14,2.34c-.84,1.02-1.12,2.36-.83,3.99,.52,.9,7.79,12.23,36.18,2.76l.85-.28-.2,.87c-.03,.11-2.53,11.24,1.67,16.68l.17,.22-.09,.26s-1.44,4.01,.11,6.69c.73,1.26,2.03,2.05,3.86,2.35l.18,.07,10.11,6.35-5.88,8.58Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 624.33,
    cy: 110.96,
    rx: 5.7,
    ry: 8.33,
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.33,119.79c-3.42,0-6.2-3.96-6.2-8.83s2.78-8.83,6.2-8.83,6.2,3.96,6.2,8.83-2.78,8.83-6.2,8.83Zm0-16.66c-2.87,0-5.2,3.51-5.2,7.83s2.33,7.83,5.2,7.83,5.2-3.51,5.2-7.83-2.33-7.83-5.2-7.83Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M665.58,292.86c-9,1.93-22.53-1.1-29.07-2.85-1.81-.48-2.35-2.39-1.8-4.2,2.63-8.7,2.86-16.24,1.82-21.76-.51-2.71,1.27-5.33,3.99-5.84,.04,0,.08-.01,.11-.02,6.34-1.05,16.97-2.61,24.01-2.62,.91,0,1.59-.85,1.36-1.74l-6.5-25.96",
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.84,293.99c-7.98,0-17.03-2.04-22.46-3.49-.84-.22-1.51-.73-1.92-1.47-.51-.92-.6-2.14-.23-3.36,2.33-7.7,2.97-15.34,1.81-21.52-.56-2.98,1.41-5.86,4.38-6.42,0,0,.12-.02,.12-.02,5.91-.97,16.89-2.61,24.09-2.63,.28,0,.55-.13,.72-.35,.17-.22,.23-.5,.16-.76l-6.5-25.96c-.07-.27,.1-.54,.36-.61,.26-.07,.54,.1,.61,.36l6.5,25.96c.14,.57,.02,1.16-.34,1.62-.36,.47-.91,.74-1.51,.74-7.13,.02-18.05,1.65-23.93,2.62l-.19-.47,.09,.49c-2.44,.46-4.05,2.82-3.59,5.26,1.19,6.33,.54,14.14-1.83,22-.29,.95-.24,1.89,.14,2.58,.28,.5,.72,.84,1.3,.99,5.63,1.51,19.71,4.8,28.84,2.84,.27-.06,.54,.11,.59,.38,.06,.27-.11,.54-.38,.59-2.09,.45-4.42,.64-6.84,.64Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M536.23,192.07l9.65,7.89s2.63,2.63,6.14,0c0,0,3.5-4.83,19.72-.45,0,0,66.63,14.45,81.09,3l30.15-19,.1,1.47,3.66,8.8s-30,11.81-31.71,24.52c0,0,.88,8.33-11.83,9.21,0,0-39.45-4.37-72.33-17.08,0,0-20.17-8.32-20.61,.88,0,0,1.45,11.91-4.17,8.88-1.11-.62-1.99-1.59-2.49-2.76-1.25-2.83-4.92-9.34-12.69-11.18l5.32-14.18Z",
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.24,228.01c-.48-.05-39.98-4.52-72.54-17.11-.15-.06-13.58-5.54-18.34-2.51-1,.64-1.52,1.6-1.59,2.95,.09,.71,.86,7.7-1.7,9.45-.86,.58-1.93,.53-3.21-.15-1.21-.67-2.17-1.74-2.71-3-1.18-2.67-4.75-9.09-12.35-10.89l-.55-.13,5.76-15.36,10.19,8.33c.13,.13,2.39,2.29,5.47,.02,.53-.62,4.7-4.75,20.2-.57,.64,.14,66.54,14.26,80.65,3.09l30.9-19.48,.15,2.22,3.82,9.19-.47,.19c-.3,.12-29.66,11.81-31.39,24.07,.03,.45,.12,3.05-1.92,5.48-2.07,2.46-5.56,3.88-10.38,4.22Zm-86.78-21.53c6.07,0,14.17,3.3,14.61,3.48,32.43,12.54,71.8,17,72.19,17.05,4.44-.31,7.69-1.61,9.58-3.85,1.93-2.28,1.7-4.79,1.7-4.82v-.06s0-.06,0-.06c1.63-12.12,27.56-23.11,31.55-24.73l-3.5-8.49-.04-.63-29.44,18.55c-14.43,11.44-78.73-2.34-81.46-2.93-15.58-4.21-19.18,.21-19.21,.26l-.1,.1c-3.81,2.86-6.76-.02-6.79-.05l-9.07-7.42-4.88,13c7.66,2.07,11.27,8.58,12.48,11.33,.46,1.07,1.27,1.96,2.28,2.53,.92,.5,1.63,.57,2.16,.2,1.75-1.2,1.51-6.6,1.27-8.59,.08-1.76,.77-3.02,2.04-3.83,1.2-.76,2.83-1.05,4.64-1.05Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.83,241.04s-.76,9.77-6.28,16.8c0,0-.44-2.19-6.14-2.19-.8,.03-1.6,0-2.4-.11-4.29-.58-8.49-1.7-12.5-3.32-.85-.33-1.77-.47-2.68-.43-3.19,.13-11.28,.24-17.48-1.83,0,0-2.2-2.63,5.25-1.76l3.95-.3c.76-.06,1.33-.73,1.27-1.49,0-.11-.03-.22-.07-.32-.19-.56-.71-.93-1.3-.93h0c-3.15,0-12.59,0-12.59-2.22,0,0-1.32-2.19,4.38-2.19h9.66c.08,0,.11-.12,.03-.14-2.84-1.06-20.06-7.66-18.46-11.69,0,0,.44-2.63,7.89,.87,0,0,9.64,3.51,13.59,2.19,0,0-16.66-7.88-15.35-11.39,0,0-.43-3.51,7,0,0,0,16.16,9.93,24.32,8.07,.45-.1,.75-.52,.78-.98,.07-1.25-.11-3.85-2.3-6.66,0,0-4.82-5.7,0-8.77,2.42,3.39,5.05,6.61,7.89,9.65,3.28,3.47,5.68,7.68,7,12.27,0,0,.63,4.64,3.73,6.48,.26,.15,.53,.28,.81,.39Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.28,259.01l-.21-1.06s-.55-1.79-5.65-1.79c-.81,.03-1.64-.01-2.46-.11-4.33-.59-8.58-1.71-12.62-3.35-.79-.3-1.62-.43-2.47-.39-4.04,.16-11.68,.14-17.66-1.86l-.13-.04-.09-.11c-.27-.32-.62-1.03-.27-1.69,.55-1.02,2.44-1.3,5.96-.89l3.85-.3c.48-.04,.84-.46,.81-.95,0-.07-.02-.14-.04-.21-.12-.35-.45-.59-.82-.59h0c-8.96,0-12.9-.78-13.08-2.59-.14-.31-.24-.86,.05-1.38,.55-.97,2.12-1.44,4.82-1.44h7.37c-5.21-2.05-14.97-6.3-16.51-9.78-.27-.6-.3-1.17-.1-1.7,.05-.18,.23-.66,.85-.98,1.39-.73,3.99-.21,7.73,1.55,.05,.02,7.5,2.71,11.78,2.42-4.46-2.2-15.21-7.9-14.26-11.23-.01-.42,.13-1.1,.76-1.55,1.2-.87,3.48-.48,6.96,1.16,.21,.12,16.14,9.83,24,8.03,.22-.05,.38-.26,.39-.52,.07-1.22-.12-3.66-2.2-6.32-.1-.11-2.65-3.17-2.19-6.17,.21-1.36,.99-2.48,2.32-3.32l.4-.25,.28,.39c2.39,3.35,5.03,6.58,7.85,9.6,3.32,3.51,5.78,7.82,7.12,12.47,.02,.11,.65,4.5,3.5,6.19,.23,.14,.48,.26,.73,.35l.35,.13-.03,.37c-.03,.41-.83,10-6.38,17.07l-.67,.85Zm-5.88-3.85c3.95,0,5.56,1.02,6.21,1.79,4.4-6.02,5.5-13.83,5.69-15.58-.18-.08-.36-.18-.53-.28-3.27-1.94-3.95-6.64-3.97-6.84-1.28-4.42-3.66-8.6-6.87-11.99-2.73-2.93-5.3-6.06-7.65-9.3-.84,.64-1.34,1.43-1.48,2.36-.39,2.55,1.96,5.37,1.98,5.4,2.29,2.94,2.5,5.66,2.42,7.01-.04,.7-.52,1.29-1.17,1.44-8.25,1.89-24.03-7.72-24.69-8.13-4.15-1.96-5.51-1.51-5.9-1.23-.39,.28-.34,.74-.34,.75v.12s-.03,.11-.03,.11c-.79,2.12,8.35,7.57,15.1,10.76l1.12,.53-1.18,.39c-4.07,1.36-13.52-2.05-13.92-2.19-4.46-2.09-6.19-1.9-6.83-1.61-.34,.16-.4,.37-.4,.37-.14,.36-.11,.68,.05,1.04,1.31,2.95,10.57,7.27,18.1,10.08l.39,.15-.03,.49c-.05,.27-.29,.47-.57,.47h-9.66c-3.07,0-3.78,.64-3.94,.92-.15,.25-.02,.49,0,.52l.06,.11v.14c0,.4,.88,1.72,12.09,1.72h0c.8,0,1.51,.51,1.77,1.27,.05,.14,.08,.29,.09,.44,.08,1.03-.69,1.94-1.72,2.02l-3.95,.3c-4.36-.5-4.98,.22-5.06,.37-.08,.14,.02,.35,.09,.47,5.81,1.9,13.22,1.91,17.14,1.75,.99-.04,1.95,.11,2.88,.46,3.98,1.61,8.14,2.72,12.39,3.29,.76,.1,1.54,.13,2.32,.11Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M288.14,200.02h0c-10.01,.16-18.26-7.82-18.42-17.84,0-.19,0-.38,0-.57v-20.6c-.01-10.16,8.21-18.4,18.37-18.41,0,0,.02,0,.03,0h0c10.17,0,18.41,8.23,18.42,18.4h0v20.61c0,10.16-8.24,18.4-18.4,18.41Z",
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.85,200.53c-10.13,0-18.46-8.16-18.62-18.33,0-.2,0-.39,0-.59v-20.59c-.01-10.42,8.45-18.9,18.87-18.91h.01c10.45,0,18.93,8.48,18.94,18.9v20.61c0,10.42-8.48,18.9-18.9,18.91-.1,0-.2,0-.3,0Zm.29-57.42h0c-9.89,.01-17.91,8.04-17.9,17.91v20.6c0,.19,0,.38,0,.57,.16,9.72,8.2,17.48,17.91,17.34h0c9.87,0,17.9-8.04,17.9-17.91v-20.61c0-9.87-8.04-17.9-17.91-17.9Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.17,192.53s4.38,6.57-1.31,14.46c0,0-7.89,10.09-3.51,19.73,0,0,4.39-9.64,25.86-15.79-.06-3.74,1.47-7.33,4.23-9.86,.75-.65,1.87-.6,2.56,.1,1.38,1.41,2.92,2.63,4.61,3.65,0,0,2.74-1.52,1.8-9.08-4.32-3.41-6.77-8.65-6.63-14.15l-.17-8.83c2.9-.64,5.46-2.34,7.18-4.76l.44,4s10.64,0,11.37-11.74v-.93c-.1-2.58,0-16.66,9.18-11.48,0,0,8.32-.44,8.77,13.15l-.18,10.83s4.12,2.32,7.19-.31c0,0,1.42-43.58-17.54-37.25-1.32,.44-19.29-18-47.34,7.46,0,0-22.58,18.5-6.51,50.8Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,227.92l-.45-.99c-4.45-9.8,3.49-20.14,3.57-20.25,5.4-7.48,1.46-13.62,1.29-13.88l-.03-.05c-16.06-32.29,6.41-51.22,6.64-51.41,24.21-21.97,40.83-11.7,46.29-8.32,.53,.33,1.08,.67,1.29,.74,3.43-1.12,6.45-.73,8.99,1.16,9.95,7.42,9.16,35.42,9.12,36.61v.22s-.17,.14-.17,.14c-3.3,2.82-7.58,.47-7.76,.37l-.26-.15,.18-11.13c-.17-4.99-1.42-8.61-3.72-10.74-2.15-1.99-4.5-1.91-4.52-1.9h-.14s-.13-.06-.13-.06c-2.1-1.19-3.83-1.39-5.14-.59-2.89,1.76-3.43,8.13-3.3,11.61v.95c-.75,12.1-11.76,12.24-11.87,12.24h-.45l-.35-3.23c-1.66,1.9-3.85,3.26-6.31,3.89l.16,8.43c-.14,5.33,2.27,10.47,6.44,13.77l.16,.13,.03,.2c.97,7.81-1.93,9.51-2.05,9.58l-.25,.14-.25-.15c-1.72-1.04-3.3-2.29-4.71-3.73-.51-.51-1.33-.55-1.88-.07-2.64,2.42-4.12,5.88-4.06,9.47v.38s-.36,.11-.36,.11c-20.94,6-25.5,15.42-25.54,15.52l-.46,.99Zm5.26-35.64c.32,.52,4.28,7.2-1.34,15-.08,.11-7.16,9.34-3.84,18.3,1.67-2.58,7.75-9.93,25.29-15.03,.04-3.74,1.63-7.31,4.39-9.85,.95-.83,2.38-.77,3.25,.12,1.27,1.29,2.68,2.43,4.21,3.39,.56-.55,2.03-2.58,1.37-8.21-4.32-3.49-6.8-8.87-6.66-14.43l-.18-9.22,.4-.09c2.79-.62,5.23-2.24,6.88-4.56l.76-1.07,.53,4.84c1.99-.15,9.81-1.35,10.42-11.25v-.9c-.04-1-.27-10.02,3.78-12.49,1.61-.98,3.64-.81,6.03,.51,.61,0,2.91,.16,5.08,2.15,2.52,2.31,3.89,6.18,4.07,11.49l-.17,10.54c.89,.41,3.87,1.57,6.19-.24,.06-2.71,.36-28.78-8.72-35.55-2.28-1.7-5.03-2.03-8.16-.99-.42,.14-.86-.14-2.05-.87-5.3-3.28-21.44-13.26-45.11,8.23-.24,.2-22.09,18.65-6.41,50.18Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.21,
    cy: 175.7,
    rx: 6.58,
    ry: 6.79,
    fill: "#f2b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.21,182.99c-3.9,0-7.08-3.27-7.08-7.29s3.18-7.29,7.08-7.29,7.08,3.27,7.08,7.29-3.18,7.29-7.08,7.29Zm0-13.58c-3.35,0-6.08,2.82-6.08,6.29s2.73,6.29,6.08,6.29,6.08-2.82,6.08-6.29-2.73-6.29-6.08-6.29Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.17,327.17c-1.27,1.88-2.99,3.41-5,4.46-7,3.38-13.8-3.14-13.8-3.14,1.31,5.26,5.7,15.34,5.7,15.34,3.51,5.26,2.63,7,2.63,7-10.27,8.77-42.41,11.29-61.39,12-6.86,.26-12,.29-13.77,.29h-.67l-2.18,45.58c-1.11,6-5.14,7.51-10.12,6.8-8.69-1.23-20.29-9.27-24.35-12.25-.94-.69-1.48-1.11-1.48-1.11l1.25-28.97c2.63-22.36,.43-50,.43-50-2.2-14.91-3.08-38.58-3.08-38.58,1.31-15.78,0-38.57,0-38.57-5.7-27.18,29.8-35.08,29.8-35.08,0-5.69,3-8.53,3-8.53,2.1-3.27,3.81-1.25,3.81-1.25,1.4,1.39,2.95,2.61,4.62,3.64,3.17,2.17,6.84,3.48,10.66,3.82,2.87,.23,5.76-.18,8.46-1.2,6.88-2.52,7.62,2.64,7.62,2.64,4.38,5.7,11.83,4.82,11.83,4.82,29.81,2.62,30.26,57.41,30.26,57.41,.88,12.71,7,7,7,7,5.69-11.83,28.92-27.62,28.92-27.62,3.51,18.5,16.67,20.21,16.67,20.21,3.94,9.64-36.82,55.29-36.82,55.29Z",
    fill: "#f6c474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.76,416.17c-.71,0-1.46-.06-2.25-.17-8.68-1.23-20.08-9.04-24.58-12.34-.95-.7-1.49-1.12-1.49-1.12l-.2-.16,1.26-29.23c2.6-22.09,.45-49.66,.43-49.94-2.18-14.73-3.07-38.36-3.08-38.6,1.29-15.62,.01-38.33,0-38.56-5.4-25.73,25.93-34.52,29.8-35.5,.12-5.26,2.71-8.06,3.11-8.45,.84-1.29,1.75-1.98,2.71-2.04,1.1-.08,1.84,.75,1.87,.79,1.34,1.32,2.86,2.52,4.5,3.54,3.11,2.12,6.71,3.42,10.44,3.75,2.77,.23,5.63-.18,8.24-1.17,2.59-.95,4.67-.97,6.19-.06,1.53,.92,1.97,2.48,2.07,2.96,4.17,5.31,11.23,4.54,11.3,4.53h.05s.05,0,.05,0c29.92,2.63,30.71,57.35,30.72,57.9,.38,5.53,1.76,7.21,2.84,7.64,1.38,.55,2.92-.66,3.25-.95,5.76-11.8,28.09-27.08,29.04-27.72l.63-.43,.14,.75c3.4,17.9,16.12,19.79,16.24,19.81l.29,.04,.11,.27c4,9.78-34.92,53.58-36.89,55.79-1.31,1.92-3.1,3.51-5.16,4.59-5.45,2.63-10.78-.47-13.13-2.21,1.62,5.38,5.22,13.67,5.26,13.76,3.53,5.27,2.72,7.22,2.62,7.43l-.12,.15c-10.46,8.93-43.14,11.43-61.7,12.12-7.1,.27-12.35,.29-13.79,.29h-.19l-2.16,45.1c-.91,4.96-3.75,7.44-8.44,7.44Zm-27.5-14.26c.24,.18,.67,.51,1.26,.95,4.44,3.26,15.67,10.96,24.12,12.16,5.49,.78,8.62-1.31,9.56-6.4l2.19-45.99h1.15c1.43,0,6.67-.02,13.75-.29,18.36-.69,50.64-3.13,60.98-11.79,.07-.35,.23-2.16-2.62-6.43-.22-.49-4.46-10.26-5.77-15.5l-.42-1.68,1.25,1.19c.07,.06,6.64,6.23,13.24,3.05,1.91-1,3.58-2.49,4.8-4.29l.04-.05c13.87-15.54,39.19-46.68,36.82-54.52-2.01-.41-13.21-3.41-16.64-19.8-3.73,2.61-23.08,16.5-28.13,26.99l-.11,.15c-.09,.08-2.22,2.05-4.36,1.2-1.97-.78-3.14-3.65-3.48-8.54,0-.57-.79-54.34-29.76-56.94-.74,.08-7.88,.65-12.23-5.02l-.08-.1-.02-.13s-.25-1.57-1.63-2.39c-1.25-.74-3.04-.69-5.32,.15-2.74,1.04-5.74,1.47-8.67,1.23-3.9-.35-7.67-1.7-10.9-3.91-1.69-1.04-3.27-2.29-4.69-3.7-.04-.05-.45-.52-1.08-.47-.63,.05-1.3,.61-1.96,1.63l-.08,.09s-2.84,2.78-2.84,8.17v.4l-.39,.09c-.35,.08-34.95,8.11-29.42,34.49,.02,.3,1.31,23.08,0,38.71,.01,.18,.91,23.75,3.08,38.47,.03,.31,2.18,27.98-.43,50.13l-1.24,28.67Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M552.92,254.44c-.28,0-.5-.22-.5-.5v-29.99c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v29.99c0,.28-.22,.5-.5,.5Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603,278.88c-7.05,0-12.4-2.91-12.62-3.04-.24-.13-.33-.44-.2-.68,.13-.24,.44-.33,.68-.2,.05,.03,5.36,2.91,12.14,2.91,.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.5,284.38c-7.04,0-10.04-1.46-10.17-1.53-.25-.12-.35-.42-.22-.67,.12-.25,.42-.35,.67-.23,.03,.01,2.96,1.42,9.72,1.42,.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.14,237.66c-.17,0-.34-.09-.43-.25-1.93-3.35-.65-8.82-.59-9.05,.06-.27,.33-.43,.6-.37,.27,.06,.43,.33,.37,.6-.01,.05-1.24,5.31,.49,8.32,.14,.24,.05,.54-.18,.68-.08,.04-.16,.07-.25,.07Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 601.15,
    y1: 390.17,
    x2: 608.83,
    y2: 341.82,
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.16,390.67s-.05,0-.08,0c-.27-.04-.46-.3-.42-.57l7.67-48.35c.04-.27,.31-.46,.57-.42,.27,.04,.46,.3,.42,.57l-7.67,48.35c-.04,.25-.25,.42-.49,.42Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.91,597.55s4.09,2.83,16.09,4.83",
    fill: "#fbe493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,602.88s-.06,0-.08,0c-11.97-2-16.12-4.79-16.29-4.91-.23-.16-.28-.47-.13-.69,.16-.23,.47-.28,.7-.13,.04,.03,4.18,2.8,15.89,4.75,.27,.05,.46,.3,.41,.58-.04,.24-.25,.42-.49,.42Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392,250.88c-.16,0-.32-.08-.42-.22-.15-.23-.09-.54,.14-.69,2.8-1.87,3.79-5.17,3.8-5.21,.08-.27,.35-.42,.62-.34,.26,.08,.42,.35,.34,.62-.04,.15-1.08,3.68-4.2,5.76-.08,.06-.18,.08-.28,.08Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55,220.5c-17.14,0-25.68-9.12-25.77-9.22-.19-.2-.17-.52,.03-.71,.21-.19,.52-.17,.71,.03,.1,.11,10.18,10.83,30.55,8.58,.27-.03,.52,.17,.55,.44,.03,.27-.17,.52-.44,.55-1.97,.22-3.84,.32-5.62,.32Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.87,363.62c-.26,0-.48-.2-.5-.47-.01-.19-1.34-19.14-5.57-36.78-.08-.22-2.26-6.68,.5-16.77,1.77-6.48,2.77-12.41,3.05-18.12,.4-8.05,.18-16.02-.65-23.7-.03-.27,.17-.52,.44-.55,.27-.03,.52,.17,.55,.44,.83,7.73,1.06,15.76,.66,23.86-.28,5.78-1.29,11.78-3.08,18.33-2.67,9.77-.53,16.16-.5,16.23,4.27,17.77,5.6,36.8,5.61,36.99,.02,.28-.19,.51-.46,.53-.01,0-.02,0-.04,0Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33,328.94c-.23,0-.44-.16-.49-.4l-6.81-34.31c-1.25-6.3-1.96-12.49-2.1-18.37-.18-7.14,.48-11.9,1.96-14.15,.15-.23,.46-.3,.69-.14,.23,.15,.29,.46,.14,.69-1.35,2.05-1.97,6.75-1.8,13.58,.14,5.83,.85,11.95,2.08,18.2l6.81,34.31c.05,.27-.12,.53-.39,.59-.03,0-.07,0-.1,0Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.63,304.15c-.23,0-.44-.16-.49-.39-.06-.27,.11-.54,.38-.6,16.08-3.6,18.44-19.15,18.46-19.31,.04-.27,.3-.46,.56-.43,.27,.04,.46,.29,.43,.56-.02,.16-2.46,16.39-19.24,20.15-.04,0-.07,.01-.11,.01Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.09,589.44s-.02,0-.04,0c-.28-.02-.48-.26-.46-.53l9.54-137.99c.02-.27,.25-.47,.53-.46,.28,.02,.48,.26,.46,.53l-9.54,137.99c-.02,.26-.24,.47-.5,.47Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,421.2c-.28,0-.5-.22-.5-.5v-7.33c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v7.33c0,.28-.22,.5-.5,.5Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.62,426.9c-.28,0-.5-.22-.5-.5v-10.23c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v10.23c0,.28-.22,.5-.5,.5Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.13,430.85c-.28,0-.5-.22-.5-.5v-10.27c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v10.27c0,.28-.22,.5-.5,.5Z",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.24,
    cy: 67.84,
    rx: 14,
    ry: 11,
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.24,79.34c-8,0-14.5-5.16-14.5-11.5s6.5-11.5,14.5-11.5,14.5,5.16,14.5,11.5-6.5,11.5-14.5,11.5Zm0-22c-7.44,0-13.5,4.71-13.5,10.5s6.06,10.5,13.5,10.5,13.5-4.71,13.5-10.5-6.06-10.5-13.5-10.5Z",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.89,
    cy: 65.1,
    rx: 10.49,
    ry: 19.52,
    transform: "translate(252.57 567.66) rotate(-60)",
    fill: "#002346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.71,78.88c-.19,0-.39,0-.58,0-4.26-.13-9.12-1.66-13.7-4.3-4.58-2.64-8.33-6.09-10.57-9.71-2.29-3.71-2.74-7.16-1.25-9.74,3.01-5.22,13.22-4.99,22.76,.51,4.58,2.64,8.33,6.09,10.57,9.71,2.29,3.71,2.74,7.16,1.25,9.74-1.42,2.46-4.42,3.8-8.48,3.8Zm-17.64-26.68c-3.57,0-6.39,1.11-7.69,3.36-1.31,2.28-.88,5.41,1.24,8.82,2.16,3.5,5.81,6.84,10.26,9.41,4.45,2.57,9.17,4.06,13.28,4.18,4.02,.12,6.94-1.06,8.26-3.34h0c1.31-2.28,.88-5.41-1.24-8.82-2.16-3.5-5.81-6.84-10.26-9.41-4.83-2.79-9.81-4.2-13.84-4.2Z",
    fill: "#002346"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetstalk);
export default __webpack_public_path__ + "static/media/letstalk.58ac45971d1a10380bbcf2d6938e79f6.svg";
export { ForwardRef as ReactComponent };